import React, {Component} from 'react'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {translate} from 'react-i18next'
import AppBar from '@material-ui/core/AppBar'
import {withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Typography from '@material-ui/core/Typography'

import * as actions from '../../../actionTypes'
import { getMoonImage } from '../../../selectors'
import GeneratePdfReport from './GeneratePdfReport'
import Report from './Report'
import Detail from './Detail'

import moment from 'moment'
import ActionModal from '../../common/ActionModal'

import {isSessionDisabled} from '../../../selectors'

const styles = theme => ({
  appBar: {marginBottom: theme.spacing.unit * 2.5},
  reportResultsContainer: {
    marginLeft: theme.spacing.unit * 2
  },
  reportHeading: {
    color: '#000000',
    fontSize: "1.75rem"
  },
  reportSubheading: {
    color: '#000000',
    fontSize: "1.4375rem"
  },
  root: {flexGrow: 1},
  tab: {width: '50%'},
  // muiTab class overrides
  selected: {borderBottomWidth: 0},
  tabRoot: {borderBottom: `2px solid ${theme.palette.action.disabled}`}
})

class ReportContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTabIndex: 1,
      emailContent: '',
      emailRecipients: '',
      isFocusOnEmailRecipients: false,
      isWarningModalVisible: false
    }
    this.amendNavigationPerDateOfBirth(this.props.dateOfBirth)
    this.props.navigator.amendNavigation({
      forward: this.sendEmailIfContentAndRecipientsPopulated,
      ignoreCdi: true
    })
  }

  addEmailFieldDataToParentState = (name, value) => {
    if (name === 'emailRecipients' && value !== '' && !this.areAllEmailRecipientsValid(value)) {
      this.setState({isWarningModalVisible: true, isFocusOnEmailRecipients: false})
    } else {
      this.setState({[name]: value})
    }
  }

  amendNavigationPerDateOfBirth = (dob) => {
    this.isDobInputValueValidForApi(dob) ? this.props.navigator.enableForward() : this.props.navigator.disableForward()
  }

  areAllEmailRecipientsValid = (value) => {
    let allEmailsValid = value.split(',').every(this.isEmailValid)
    allEmailsValid || value === '' ? this.props.navigator.enableForward() : this.props.navigator.disableForward()
    return allEmailsValid
  }

  closeEmailRecipientModal = () => {
    this.setState({isWarningModalVisible: false, isFocusOnEmailRecipients: true})
  }

  handleTabChange(activeTabIndex) {
    this.setState({activeTabIndex})
  }

  hasDetails() {
    const {firstName, lastName, medicalRecordNumber} = this.props
    return firstName || lastName || medicalRecordNumber
  }

  // NOTE: API accepts valid moment OR a null value as an empty string
  isDobInputValueValidForApi = (dob) => {
    if (dob === '') {
      return true
    } else {
      return moment(dob, 'YYYY-MM-DD', true).isValid()
    }
  }

  isEmailValid = (email) => {
    const reg = /^[\w!#$%&'*+\-/=?^_`{|}~]+(\.[\w!#$%&'*+\-/=?^_`{|}~]+)*@((([-\w]+\.)+[a-zA-Z]{2,4})|(([0-9]{1,3}\.){3}[0-9]{1,3}))$/;
    return reg.test(email.trim())
  }

  renderWarningModal() {
    const {t} = this.props
    const modalContent = 'Enter Email Recipients'
    const dismissText = 'Ok'

    return (
      <ActionModal
        open={this.state.isWarningModalVisible}
        content={t(modalContent)}
        dismissText={t(dismissText)}
        onDismiss={this.closeEmailRecipientModal}
      />
    )
  }

  sendEmailIfContentAndRecipientsPopulated = () => {
    if (this.state.emailRecipients !== '') {
      this.props.sendEmailFromReportContainer(this.state.emailRecipients, this.state.emailContent, this.props.sessionId, this.props.lang)
    }
    return true
  }

  setLikelyOption = () => {
    if (this.props.finalWeight > 0.00) {
      if (this.props.finalWeight > 0.545) { return 1 }
      if (this.props.finalWeight < 0.455) { return 2 }
      return 0 // neutral
    } else {
      // no decision; technically, should never occur
      // TODO: backlogged... throw error to User (?), likely remove this return value
      return -1
    }
  }

  sendEmail = () => {
    this.sendEmailIfContentAndRecipientsPopulated()

    this.setState({
      emailRecipients: '',
      emailContent: ''
    })
  }

  render() {
    const {classes, t, moonImage, factorsOption1, factorsOption2} = this.props
    const {activeTabIndex} = this.state
    const topFactorsOptions = {
      option1: factorsOption1.filter(factor => {
        return this.props.topFactors.includes(factor)
      }),
      option2: factorsOption2.filter(factor => {
        return this.props.topFactors.includes(factor)
      })
    }

    return (
      <div className={classes.root}>
        <AppBar
          color="default"
          className={classes.appBar}
          position="static"
        >
          <Tabs
            centered
            onChange={(event, value) => this.handleTabChange(value)}
            value={activeTabIndex}
          >
          <Tab
            classes={{
              root: classes.tabRoot,
              selected: classes.selected
            }}
            className={classes.tab}
            label={t('Client')}
          />
          <Tab
            classes={{
              root: classes.tabRoot,
              selected: classes.selected
            }}
            className={classes.tab}
            label={t('Results')}
          />
          </Tabs>
        </AppBar>

        <Grid
          alignContent="space-around"
          container
          justify="center"
          spacing={8}
        >

          {activeTabIndex === 0 && (
            <React.Fragment>
              <Grid item xs={10} >
                <Typography variant="headline" className={classes.reportHeading}>{t('Decision Counseling Session')} - {t('Client')}</Typography>
              </Grid>
              <Grid item xs={10}>
                <Detail
                  addPatientDetails={this.props.addPatientDetails}
                  amendNavigationPerDateOfBirth={this.amendNavigationPerDateOfBirth}
                  caseId={this.props.caseId}
                  dateOfBirth={this.props.dateOfBirth}
                  isDobInputValueValidForApi={this.isDobInputValueValidForApi}
                  firstName={this.props.firstName}
                  lastName={this.props.lastName}
                  medicalRecordNumber={this.props.medicalRecordNumber}
                  isCounselingSessionDisabled={this.props.isCounselingSessionDisabled}
                />
              </Grid>
            </React.Fragment>
          )}

          {activeTabIndex === 1 && (
            <React.Fragment>
              <Grid item xs={10} >
                <Typography variant="headline" className={classes.reportHeading}> {t('Decision Counseling Session')} - {t('Results')}
                <GeneratePdfReport disablePdf={this.props.isRequestingSessionSave}/>
                </Typography>
              </Grid>

              <Grid item xs={10} >
                <Typography variant="headline" className={classes.reportSubheading}> <span style={{fontWeight: 'bold'}}> {this.props.decisionName}</span> {" "}
                {this.props.optionsResultsArray[this.setLikelyOption()]}
                </Typography>
              </Grid>

              <Grid container item justify="center" xs={10}>
                <Report
                  addEmailFieldDataToParentState={this.addEmailFieldDataToParentState}
                  areAllEmailRecipientsValid={this.areAllEmailRecipientsValid}
                  counselor={`${this.props.counselorFirstName} ${this.props.counselorLastName}`}
                  decisionName={this.props.decisionName}
                  finalWeight={this.props.finalWeight}
                  isFocusOnEmailRecipients={this.state.isFocusOnEmailRecipients}
                  medicalRecordNumber={this.props.medicalRecordNumber}
                  optionsArray={this.props.optionsArray}
                  optionsResultsArray={this.props.optionsResultsArray}
                  sendEmail={() => this.sendEmail()}
                  setLikelyOption={this.setLikelyOption}
                  topFactorsOptions={topFactorsOptions}
                  updateUserComments={this.props.updateUserComments}
                  userComments={this.props.userComments}
                  moonImage={moonImage}
                  isCounselingSessionDisabled={this.props.isCounselingSessionDisabled}
                />
              </Grid>
            </React.Fragment>
          )}
        </Grid>
        {this.renderWarningModal()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  caseId: state.counselingSession.counselingSessionData.caseId,
  counselorFirstName: state.counselingSession.counselingSessionData.counselorFirstName,
  counselorLastName: state.counselingSession.counselingSessionData.counselorLastName,
  dateOfBirth: state.counselingSession.counselingSessionData.dateOfBirth,
  decisionName: state.counselingSession.counselingSessionData.decisionName,
  medicalRecordNumber: state.counselingSession.counselingSessionData.medicalRecordNumber || '',
  finalWeight: state.counselingSession.counselingSessionData.finalWeight,
  firstName: state.counselingSession.counselingSessionData.firstName || '',
  lang: state.globalSettings.lang,
  lastName: state.counselingSession.counselingSessionData.lastName || '',
  moonImage: getMoonImage(state),
  optionsArray: state.counselingSession.counselingSessionData.options,
  optionsResultsArray: state.counselingSession.counselingSessionData.optionsResults,
  sessionId: state.counselingSession.sessionId,
  topFactors: state.counselingSession.counselingSessionData.topThreeFactors,
  userComments: state.counselingSession.counselingSessionData.userComments,
  isRequestingSessionSave: state.counselingSession.isRequestingSessionSave,
  factorsOption1: state.counselingSession.counselingSessionData.factorsOption1,
  factorsOption2: state.counselingSession.counselingSessionData.factorsOption2,
  isCounselingSessionDisabled: isSessionDisabled(state)
})

const mapDispatchToProps = dispatch => ({
  addPatientDetails(name, value) {
    const action = {type: actions.ADD_PATIENT_DETAILS, payload: {name, value}}
    dispatch(action)
  },
  sendEmailFromReportContainer(recipients, content, sessionId, lang) {
    const action = {type: actions.SEND_EMAIL_REQUEST, payload: {recipients, content, sessionId, lang}}
    dispatch(action)
  },
  updateUserComments(comments) {
    const action = {type: actions.UPDATE_USER_COMMENTS_REQUESTED, payload: {comments}}
    dispatch(action)
  }
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
  withStyles(styles)
)(ReportContainer)



// WEBPACK FOOTER //
// ./src/components/counseling-session/report/ReportContainer.js